import React, { Component } from 'react';

const Scrollable = props =>
  <div style={{overflowY: 'auto', width: '100%', height: props.height}}>
    {props.children}
  </div>;

export default Scrollable;
